(() => {
 const rootSelector = ':is(#shopify-section-announcement-bar,[id$="__announcement-bar"])';
 const setup = () => {
  document.querySelectorAll(rootSelector).forEach(root => {
   const row = root.querySelector('[data-announcement-bar]');
   if (!row || row.dataset.asosReady) return;
   if (window.jQuery && window.jQuery(row).hasClass('slick-initialized')) window.jQuery(row).slick('unslick');
   row.dataset.asosReady = 'true';
   row.removeAttribute('data-announcement-bar');
   const slides = Array.from(row.querySelectorAll('.announcement-bar__message'));
   let index = 0, timer;
   const show = next => {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => { slide.style.setProperty('display', i === index ? 'block' : 'none', 'important'); slide.setAttribute('aria-hidden', String(i !== index)); });
   };
   const stop = () => clearInterval(timer);
   const play = () => { stop(); if (!matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => { if (!document.hidden) show(index + 1); }, 7000); };
   [['prev','Mensagem anterior',-1],['next','Próxima mensagem',1]].forEach(([direction,label,step]) => {
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'slick-arrow slick-' + direction; button.setAttribute('aria-label', label);
    button.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="' + (step === 1 ? 'M7 4l6 6-6 6' : 'M13 4l-6 6 6 6') + '" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    button.addEventListener('click', () => { show(index + step); stop(); });
    row.append(button);
   });
   row.addEventListener('mouseenter', stop); row.addEventListener('mouseleave', play);
   row.addEventListener('focusin', stop); row.addEventListener('focusout', play);
   show(0); play();
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
 document.addEventListener('shopify:section:load', setup);
 document.addEventListener('click', async event => {
  const button = event.target.closest(rootSelector + ' [data-asos-top-copy]');
  if (!button) return;
  const label = button.querySelector('[data-copy-label]');
  try {
   await navigator.clipboard.writeText(button.dataset.asosTopCopy);
   label.textContent = 'Copiado!'; button.setAttribute('aria-label', 'Cupom copiado');
   setTimeout(() => { label.textContent = button.dataset.asosTopCopy; button.setAttribute('aria-label', 'Copiar cupom ' + button.dataset.asosTopCopy); }, 3000);
  } catch { button.setAttribute('aria-label', 'Use o cupom ' + button.dataset.asosTopCopy); }
 });
})();
/* Encerramento do aviso temporário, incluindo vitrines carregadas por AJAX. */
(() => {
  'use strict';
  const end = Date.parse('2026-10-01T02:59:59Z');
  let timer;
  let observer;
  const hide = (root) => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('[data-asos-card-promo]')) root.hidden = true;
    root.querySelectorAll('[data-asos-card-promo]').forEach((notice) => { notice.hidden = true; });
  };
  const check = () => {
    clearTimeout(timer);
    const remaining = end - Date.now();
    if (remaining > 0) {
      timer = setTimeout(check, Math.min(remaining, 2147483647));
      return;
    }
    hide(document);
    if (!observer && document.body) {
      observer = new MutationObserver((records) => {
        records.forEach((record) => record.addedNodes.forEach(hide));
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check, { once: true });
  else check();
  document.addEventListener('visibilitychange', check);
  window.addEventListener('pageshow', check);
})();


// Vitrine da home: rolagem nativa, abas e paginação acessível.
(function () {
  function mountShowcases(root) {
    root.querySelectorAll('[data-asos-showcase]').forEach(function (section) {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const tabs = Array.from(section.querySelectorAll('[data-showcase-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-showcase-panel]'));
      function setupDots(panel) {
        const track = panel.querySelector('.asos-home-showcase__track');
        const nav = panel.querySelector('[data-showcase-dots]');
        if (panel.hidden || !track.children.length) return;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const first = track.children[0];
        const step = first.offsetWidth + parseFloat(getComputedStyle(track).gap || 0);
        const perPage = Math.max(1, Math.floor((track.clientWidth + parseFloat(getComputedStyle(track).gap || 0) + 1) / step));
        const distance = step * perPage;
        const positions = [0];
        for (let x = distance; x < max - 2; x += distance) positions.push(x);
        if (max > 2) positions.push(max);
        nav.replaceChildren();
        if (positions.length === 1) return;
        positions.forEach(function (position, i) {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', 'Página ' + (i + 1));
          button.addEventListener('click', function () {
            track.scrollTo({left:position, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          });
          nav.appendChild(button);
        });
        panel._updateDots = function () {
          let closest = 0;
          positions.forEach(function (position, i) { if (Math.abs(track.scrollLeft - position) < Math.abs(track.scrollLeft - positions[closest])) closest = i; });
          Array.from(nav.children).forEach(function (button, i) {
            if (i === closest) button.setAttribute('aria-current', 'true');
            else button.removeAttribute('aria-current');
          });
        };
        panel._updateDots();
      }
      function select(index, focus) {
        tabs.forEach(function (tab, i) {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        const all = section.querySelector('[data-showcase-all]');
        all.href = tabs[index].dataset.collectionUrl;
        setupDots(panels[index]);
        if (focus) tabs[index].focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i, false); });
        tab.addEventListener('keydown', function (e) {
          let index;
          if (e.key === 'ArrowRight') index = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') index = (i + tabs.length - 1) % tabs.length;
          if (e.key === 'Home') index = 0;
          if (e.key === 'End') index = tabs.length - 1;
          if (index !== undefined) { e.preventDefault(); select(index, true); }
        });
      });
      panels.forEach(function (panel) {
        const track = panel.querySelector('.asos-home-showcase__track');
        let scheduled = false;
        track.addEventListener('scroll', function () {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(function () { scheduled = false; if (panel._updateDots) panel._updateDots(); });
        }, {passive:true});
      });
      const observer = new ResizeObserver(function () { panels.forEach(setupDots); });
      panels.forEach(function (panel) { observer.observe(panel.querySelector('.asos-home-showcase__track')); });
      section._showcaseObserver = observer;
      panels.forEach(setupDots);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mountShowcases(document); }, {once:true});
  else mountShowcases(document);
  document.addEventListener('shopify:section:load', function (e) { mountShowcases(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { e.target.querySelectorAll('[data-asos-showcase]').forEach(function (section) { if (section._showcaseObserver) section._showcaseObserver.disconnect(); }); });
})();


(function () {
  const selector = '#MainContent .halo-product-block .products-carousel, #MainContent .halo-product-block .products-flex, #MainContent .halo-product-block .products-grid.slider, #MainContent .cust-prod-widget__products--slider';
  function mount(root) {
    root.querySelectorAll(selector).forEach(function (track) {
      if (track._asosDots) return;
      const nav = document.createElement('div');
      nav.className = 'asos-home-showcase__dots asos-home-vitrine-dots';
      nav.setAttribute('aria-label', 'Navegar pelos produtos');
      const scrollContent = track.classList.contains('products-flex') ? track.closest('.halo-block-content') : null;
      if (scrollContent) scrollContent.after(nav);
      else track.after(nav);
      track.classList.add('asos-home-paginated-track');
      let frame = 0;
      let positions = [];
      let slick = null;
      let signature = '';
      function update() {
        frame = 0;
        if (!track.isConnected || !track.clientWidth) { nav.hidden = true; return; }
        const jq = window.jQuery;
        slick = jq && track.classList.contains('slick-initialized') ? jq(track).slick('getSlick') : null;
        let active = 0;
        if (slick) {
          const perPage = Math.max(1, Math.floor(slick.options.slidesToShow));
          const max = Math.max(0, slick.slideCount - perPage);
          positions = [0];
          for (let i = perPage; i < max; i += perPage) positions.push(i);
          if (max > 0) positions.push(max);
          positions.forEach(function (position, i) {
            if (Math.abs(slick.currentSlide - position) < Math.abs(slick.currentSlide - positions[active])) active = i;
          });
        } else {
          const cards = Array.from(track.children).filter(function (card) { return card.classList.contains('product'); });
          const max = Math.max(0, track.scrollWidth - track.clientWidth);
          const first = cards[0];
          const step = cards.length > 1 ? cards[1].offsetLeft - first.offsetLeft : track.clientWidth;
          const perPage = Math.max(1, Math.round(track.clientWidth / Math.max(1, step)));
          const distance = Math.max(1, step * perPage);
          positions = [0];
          for (let x = distance; x < max - 2; x += distance) positions.push(x);
          if (max > 2) positions.push(max);
          positions.forEach(function (position, i) {
            if (Math.abs(track.scrollLeft - position) < Math.abs(track.scrollLeft - positions[active])) active = i;
          });
        }
        nav.hidden = positions.length < 2;
        const nextSignature = (slick ? 'slick:' : 'scroll:') + positions.join(',');
        if (nextSignature !== signature) {
          signature = nextSignature;
          nav.replaceChildren();
          positions.forEach(function (_, i) {
            const button = document.createElement('button');
            button.type = 'button';
            button.setAttribute('aria-label', 'Página ' + (i + 1));
            button.addEventListener('click', function () {
              if (slick) window.jQuery(track).slick('slickGoTo', positions[i]);
              else track.scrollTo({left: positions[i], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
            });
            nav.appendChild(button);
          });
        }
        Array.from(nav.children).forEach(function (button, i) {
          if (i === active) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      }
      function schedule() { if (!frame) frame = requestAnimationFrame(update); }
      const resize = new ResizeObserver(schedule);
      const mutation = new MutationObserver(schedule);
      resize.observe(track);
      mutation.observe(track, {childList:true, subtree:true});
      track.addEventListener('scroll', schedule, {passive:true});
      if (window.jQuery) window.jQuery(track).on('init.asosDots reInit.asosDots afterChange.asosDots breakpoint.asosDots setPosition.asosDots', schedule);
      track._asosDots = {resize:resize, mutation:mutation};
      schedule();
    });
  }
  function start() {
    mount(document);
    const observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1 || node.closest('.asos-home-vitrine-dots')) return;
          if (node.matches(selector)) mount(node.parentElement);
          else mount(node);
        });
      });
    });
    if (window.Shopify && window.Shopify.designMode) {
      observer.observe(document.getElementById('MainContent') || document.body, {childList:true, subtree:true});
    }
    document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll(selector).forEach(function (track) {
        if (track._asosDots) { track._asosDots.resize.disconnect(); track._asosDots.mutation.disconnect(); }
        if (window.jQuery) window.jQuery(track).off('.asosDots');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

function copyToClipboard(element) {
  var $temp = $("<input>");
  var oldValue = $(element).html();

  $("body").append($temp);
  $temp.val($(element).html()).select();
  document.execCommand("copy");
  $(element).html("COPIADO");
  setTimeout(function(){ $(element).html(oldValue); }, 300);
  $temp.remove();
}

$('cupom').click(function(){
  copyToClipboard(this);
});

(function() {
  const params = new URLSearchParams(window.location.search);
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  const attributes = {};

  utmParams.forEach(param => {
    const value = params.get(param);
    if (value) {
      attributes[`${param}`] = value;
    }
  });

  if (Object.keys(attributes).length > 0) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ attributes })
    });
  }
})();

if (window.location.pathname === '/products/sache-sabonete-intimo-hidratante-feminino-dermosex-4-ml' || window.location.pathname === '/products/brinde-sache-creme-corporal-super-hidratante-dermosex-4g') {
  window.location.replace('/');
}

// A SÓS | Busca do cabeçalho desktop (o layout do cabeçalho vive no custom.css)
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 1025) return;

  document
    .querySelectorAll(
      '.section-header-navigation .header-nav-vertical-menu details-modal.header__search'
    )
    .forEach(function (modal) {
      const details = modal.querySelector('details.search_details');
      const summary = details && details.querySelector('summary.header__icon--search');

      if (!details || !summary) return;

      summary.addEventListener(
        'click',
        function () {
          requestAnimationFrame(function () {
            const isOpen = details.hasAttribute('open');
            document.body.classList.toggle('sticky-search-menu-open', isOpen);
            summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          });
        },
        true
      );

      details.addEventListener('toggle', function () {
        const isOpen = details.hasAttribute('open');
        document.body.classList.toggle('sticky-search-menu-open', isOpen);
        summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      const closeButton = details.querySelector('.search-modal__close-button');
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          document.body.classList.remove('sticky-search-menu-open');
          summary.setAttribute('aria-expanded', 'false');
        });
      }
    });
});

// A SÓS | Fecha a busca desktop ao clicar na área vazia ao redor do conteúdo
(function () {
  'use strict';

  function setupSearchOutsideClose() {
    if (window.innerWidth < 1025) return;

    document.addEventListener('click', function (event) {
      const details = document.querySelector(
        '.header-nav-vertical-menu .header__search details.search_details[open]'
      );

      if (!details) return;

      const searchContent = details.querySelector('predictive-search.search-modal__form');
      const closeButton = event.target.closest('.header-search-close');

      if (closeButton || (searchContent && searchContent.contains(event.target))) return;

      const overlay = event.target.closest('.search-modal.modal__content');
      if (!overlay || !details.contains(overlay)) return;

      details.removeAttribute('open');
      document.body.classList.remove('sticky-search-menu-open', 'open_search');

      const summary = details.querySelector('summary[data-search-menu]');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
        summary.focus({ preventScroll: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupSearchOutsideClose, { once: true });
  } else {
    setupSearchOutsideClose();
  }
})();

// A SÓS | Guia de escolha na Home
(function () {
  const ID = 'asos-whatsapp-guide';
  function mount() {
    if (!document.body.classList.contains('template-index') || document.getElementById(ID)) return;
    const target = [...document.querySelectorAll('.shopify-section')].find(section => (section.textContent || '').replace(/\s+/g, ' ').toLowerCase().includes('o que você está buscando?'));
    if (!target) return;
    const el = document.createElement('div');
    el.id = ID;
    el.innerHTML = '<p>Precisa de ajuda para escolher?</p><a href="https://wa.me/553140420099?text=Oi.%20Vim%20pelo%20site%20da%20A%20S%C3%B3s%20e%20gostaria%20de%20ajuda%20para%20escolher%20um%20produto." target="_blank" rel="noopener noreferrer">Fale com a A Sós <span aria-hidden="true">›</span></a>';
    (target.querySelector('.container, .container-1170, .container-1370, .container-1570') || target).appendChild(el);
    el.querySelector('a').addEventListener('click', () => window.dataLayer?.push({event:'asos_whatsapp_guide_submit',source:'home_whatsapp_guide',guide_intent:'Ajuda para escolher'}));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true});
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();

// Navegação visível do banner da home, independente dos indicadores gerados pelo Slick.
(function () {
  function setupHeroDots() {
    const frame = document.querySelector('.asos-home-hero .asos-home-hero-frame');
    if (!frame || frame.dataset.asosDotsReady === 'true' || !window.jQuery) return;
    frame.dataset.asosDotsReady = 'true';
    const $slider = window.jQuery(frame).find('.slideshow');
    const dots = Array.from(frame.querySelectorAll('.asos-home-hero-dot'));
    function select(index) {
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    frame.querySelector('.asos-home-hero-dots').addEventListener('click', function (event) {
      const dot = event.target.closest('.asos-home-hero-dot');
      if (!dot || !$slider.hasClass('slick-initialized')) return;
      $slider.slick('slickGoTo', Number(dot.dataset.slideIndex));
    });
    $slider.on('init.asosHeroDots reInit.asosHeroDots afterChange.asosHeroDots', function (event, slick, index) {
      select(typeof index === 'number' ? index : slick.currentSlide || 0);
    });
    if ($slider.hasClass('slick-initialized')) select($slider.slick('slickCurrentSlide'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupHeroDots, { once: true });
  else setupHeroDots();
  document.addEventListener('shopify:section:load', setupHeroDots);
})();

(function () {
  'use strict';
  function mountCategoryCarousel() {
    const section = document.querySelector('.shopify-section[id$="__1632304586ad9b5b3b"]');
    const track = section && section.querySelector('[data-brands-slider]');
    if (!track || track.dataset.asosPairsReady || !window.jQuery) return;
    track.dataset.asosPairsReady = 'true';
    const $track = window.jQuery(track);
    const mobile = window.matchMedia('(max-width: 767px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let configured = false, visible = false, touching = false, focused = false;
    function sync() {
      if (!configured || !$track.hasClass('slick-initialized')) return;
      const play = mobile.matches && !reduced.matches && visible && !document.hidden && !touching && !focused;
      $track.slick(play ? 'slickPlay' : 'slickPause');
    }
    function configure() {
      if (configured || !$track.hasClass('slick-initialized')) return;
      configured = true;
      const slick = $track.slick('getSlick');
      const responsive = (slick.originalSettings.responsive || []).map(function (entry) {
        if (entry.breakpoint > 768) return entry;
        return {
          breakpoint: entry.breakpoint,
          settings: Object.assign({}, entry.settings, {
            slidesToShow: 2, slidesToScroll: 2, infinite: true,
            autoplay: false, autoplaySpeed: 4000,
            arrows: false, dots: false, centerMode: false
          })
        };
      });
      slick.originalSettings.responsive = responsive;
      $track.slick('slickSetOption', 'responsive', responsive, true);
      $track.slick('slickSetOption', 'autoplaySpeed', 4000, false);
      sync();
    }
    $track.on('init.asosCategoryPairs', function () { queueMicrotask(configure); });
    $track.on('reInit.asosCategoryPairs breakpoint.asosCategoryPairs', sync);
    function down() { touching = true; sync(); }
    function release() { touching = false; sync(); }
    function focusIn() { focused = true; sync(); }
    function focusOut(event) {
      if (!section.contains(event.relatedTarget)) { focused = false; sync(); }
    }
    track.addEventListener('pointerdown', down, { passive: true });
    window.addEventListener('pointerup', release, { passive: true });
    window.addEventListener('pointercancel', release, { passive: true });
    section.addEventListener('focusin', focusIn);
    section.addEventListener('focusout', focusOut);
    mobile.addEventListener('change', sync);
    reduced.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      sync();
    }, { threshold: 0.5 }) : null;
    if (observer) observer.observe(track);
    else visible = true;
    function unload(event) {
      if (event.target !== section) return;
      if (observer) observer.disconnect();
      $track.off('.asosCategoryPairs');
      window.removeEventListener('pointerup', release);
      window.removeEventListener('pointercancel', release);
      mobile.removeEventListener('change', sync);
      reduced.removeEventListener('change', sync);
      document.removeEventListener('visibilitychange', sync);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    configure();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountCategoryCarousel, { once: true });
  else mountCategoryCarousel();
  document.addEventListener('shopify:section:load', mountCategoryCarousel);
})();

